import * as olStyle from 'ol/style';

/** origin/main DotMapStyle.js 와 동일한 상수·스타일 (지도 결함 아이콘·모듈·RGB 위치) */
const APP_DEFECT_ICONS_URI = '/img/icons/defect/';
const APP_RGBIMG_ICONS_URI = '/img/icons/imagePos.png';

/** [DEFECT-MAP-DEBUG] 제거 시 함께 삭제 — 첫 피처 속성만 1회 출력 (레이어 갱신 시 리셋) */
let defectStyleDebugLogged = false;

export function resetDefectStyleDebugLog() {
  defectStyleDebugLogged = false;
}

/** 대시보드 모듈 모드 — Polygon(꼭지) / Point(center) 모두 보이게 */
export function solarModule(feature) {
  const geom = feature?.getGeometry?.();
  const type = geom?.getType?.();

  if (type === 'Point' || type === 'MultiPoint') {
    return new olStyle.Style({
      image: new olStyle.Circle({
        radius: 5,
        fill: new olStyle.Fill({ color: 'rgba(33, 150, 243, 0.75)' }),
        stroke: new olStyle.Stroke({ color: 'rgba(255, 255, 255, 0.95)', width: 1.5 })
      })
    });
  }

  return new olStyle.Style({
    stroke: new olStyle.Stroke({
      color: 'rgba(33, 150, 243, 0.9)',
      width: 2
    }),
    fill: new olStyle.Fill({
      color: 'rgba(33, 150, 243, 0.15)'
    })
  });
}

/**
 * 결함 상태에 따라 모듈 폴리곤 색상 적용
 * 🟩 초록: 결함 없음
 * 🟨 노랑: 결함 있음 (1건 이상)
 */
export function solarModuleByDefectStatus(defectStats) {
  const { count } = defectStats || {};

  let fillColor;
  let strokeColor;

  if (count > 0) {
    // 결함 1건 이상 → 노랑 (SCHEDULE 구분 없이, 결함 유무만 표시)
    fillColor = 'rgba(255, 193, 7, 0.2)';
    strokeColor = 'rgba(255, 193, 7, 0.9)';
  } else {
    // 결함 없음 → 초록
    fillColor = 'rgba(76, 175, 80, 0.15)';
    strokeColor = 'rgba(76, 175, 80, 0.7)';
  }

  return new olStyle.Style({
    stroke: new olStyle.Stroke({ color: strokeColor, width: 2 }),
    fill: new olStyle.Fill({ color: fillColor })
  });
}

export function defectModule(feature) {
  if (!defectStyleDebugLogged) {
    defectStyleDebugLogged = true;
    try {
      console.log('[DEFECT-MAP-DEBUG] defectModule first feature props', feature.getProperties());
    } catch (e) {
      console.warn('[DEFECT-MAP-DEBUG] defectModule props log failed', e);
    }
  }
  const raw = feature.getProperties().defect_type;
  const iconName = raw == null || raw === '' ? 'cell' : String(raw).toLowerCase();

  return new olStyle.Style({
    image: new olStyle.Icon({
      anchor: [0.5, 1],
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      scale: 0.5,
      src: APP_DEFECT_ICONS_URI + iconName + '.png'
    })
  });
}

/** 결함 리스트 → 지도 이동 시 해당 모듈 사각형 강조 */
export function defectFocusModuleHighlightStyles() {
  return [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: 'rgba(255, 255, 255, 0.95)',
        width: 5,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({ color: 'rgba(0, 0, 0, 0)' })
    }),
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: 'rgba(211, 47, 47, 0.95)',
        width: 3,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({
        color: 'rgba(255, 82, 82, 0.28)'
      })
    })
  ];
}

export function imageViewStyle(feature) {
  console.log('[debug] image view style', feature);
  return new olStyle.Style({
    image: new olStyle.Icon({
      anchor: [0.5, 30],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: APP_RGBIMG_ICONS_URI
    })
  });
}
